@use "ui/styles/colors";
@use "ui/styles/fonts";

.lotOverviewFields {
  fieldset {
    border: none;
    margin: 0;
    padding: 0;

    & > div {
      width: 50%;
      &:not(:last-of-type) {
        margin-right: 18px;
      }
    }
  }

  .row {
    display: flex;
  }

  :global {
    .inputWithRadioGroupContainer {
      display: flex;
      // The radio group has no label of its own, so align it with the input's own
      // row rather than the labeled input's top edge. Using flex alignment (instead of a
      // fixed position/top offset) keeps this correct however tall the input or radio
      // labels grow, so a long custom radio label wrapping to multiple lines can't push
      // the radio group down into content that follows this row.
      align-items: flex-end;

      &.wide {
        width: 100%;
      }
    }
  }
}

.addressPreview {
  margin-top: 6px;
  font-size: fonts.$small;
  color: colors.$gray50;

  .addressPreviewValue {
    color: colors.$gray60;
  }

  .addressPreviewMuted {
    font-style: italic;
  }
}
